import Typography from "@mui/material/Typography";

const translatedText = JSON.parse(sessionStorage.getItem("TranslationText"));
function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align={props.align}
      {...props}
    >
      {"©"} {new Date().getFullYear()}
          {"."} www.indas.com Laboratórios INDAS S.A.U. a part of Attindas Hygiene Partner
          {translatedText?.copyright}
    </Typography>
  );
}
export default Copyright;
